import React from "react";
import { Divider, Icon, Image } from "semantic-ui-react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { LIAA_LOGO } from "images/imageSources";

import MainGrid from "./MainGrid";

import ListLoader, { definedListLoaderType } from "../atoms/Loaders/ListLoader";
import Typography from "../atoms/Typography/Typography";
import { definedTypographyTypes } from "../atoms/Typography/TypographyStyles";
import { definedButtonTypes } from "../atoms/Buttons/SimpleButton/SimpleButton";
import { definedCardTypes } from "../molecules/Cards/EventGridCard";
import LinkButton from "../atoms/Buttons/LinkButton";

const StyledDiv = styled.div({
  textAlign: "right",
  marginTop: "0.5em",
});
const HeadingDiv = styled.div({
  display: "flex",
  justifyContent: "space-evenly",
  img: {
    marginLeft: "10px",
  },
  h4: {
    marginBottom: "0.5em",
  },
  a: {
    display: "inline-block",
  },
  "#liaa-collab": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
interface Props {
  heading?: string;
  loading?: boolean;
  rows?: number;
  gridTag: string;
  type?: definedCardTypes;
  showMore?: boolean;
  showAll?: boolean;
  href?: string;
  showAllUrl?: string;
  hrefText?: string;
}

const DynamicCardList: React.FC<Props> = ({
  children,
  heading,
  gridTag: listTag,
  loading,
  rows,
  type,
  showMore,
  showAll,
  href,
  showAllUrl,
  hrefText,
}) => {
  const { t } = useTranslation();
  let loaderType = definedListLoaderType.default;
  if (type === definedCardTypes.organization) {
    loaderType = definedListLoaderType.bigLoader;
  }
  return (
    <div>
      {heading && (
        <>
          {listTag === "importantEvents" ? (
            <HeadingDiv>
              <div id="headingText">
                <Typography type={definedTypographyTypes.title1}>
                  {heading}
                </Typography>
                <div id="liaa-collab">
                  <Typography type={definedTypographyTypes.caption}>
                    {t("InCollaborationWith")}
                  </Typography>
                  <a
                    href="https://www.liaa.gov.lv/"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="liaa"
                  >
                    <Image src={LIAA_LOGO} alt="LIAA" size="tiny" />
                  </a>
                </div>
              </div>
            </HeadingDiv>
          ) : (
            <Typography type={definedTypographyTypes.title1}>
              {heading}
            </Typography>
          )}
          <Divider />
        </>
      )}
      {loading ? (
        <ListLoader rows={rows || 4} keyTag={listTag} type={loaderType} />
      ) : (
        <MainGrid columns={1} className={listTag} fitted list>
          {children}
        </MainGrid>
      )}

      {showMore && (
        <StyledDiv>
          <LinkButton
            to={href || "/"}
            id={`showRest${heading}`}
            variant={definedButtonTypes.miniAction}
          >
            {hrefText || t("Buttons.ShowRest")}
            <Icon name="angle right" />
          </LinkButton>
        </StyledDiv>
      )}
      {showAll && (
        <StyledDiv>
          <LinkButton
            to={showAllUrl || href || "/"}
            id={`showAll${heading}`}
            variant={definedButtonTypes.action}
          >
            {hrefText || t("Buttons.ShowAll")}
            <Icon name="angle right" />
          </LinkButton>
        </StyledDiv>
      )}
    </div>
  );
};

export default DynamicCardList;
